import React from 'react';
import "./Login.css"

import loginImage from "./login.png";
import { Link } from 'react-router-dom';

const Login = () => {
  
  return (
    <div className="login-container">
      <div className="image-section">
        <img src={loginImage} alt="Login Illustration" />
      </div>
      <div className="login-section">
        <h1>Transforming <br></br> Your Business Outlook</h1>
        <p>Login and show how you can change your outlook towards your career</p>
        <div className="social-login">
          <button className="google-btn">
           <Link to="https://coreui.io/demos/react/5.0/free/?theme=light#/dashboard">
            Login with Google</Link>
          </button>
          <button className="linkedin-btn">
          
            Login with LinkedIn
          </button>
        </div>
        <div class="divider">
          <hr class="dividerline"></hr>
          <span class="dividertext">OR</span>
          <hr class="dividerline"></hr>
        </div>


        <form className="login-form">
          <div className=" emailgroup">
            <h5>EMAIL ADDRESS</h5>
            <input type="email" placeholder="Enter you Email Adress" required />
          </div>
          <div className=" passwordgroup">
            <h5>PASSWORD</h5>
            <input type="password" placeholder="Password" required />
          </div>
          
          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
}

export default Login;
